import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import get from 'lodash/get'
import { divisionAction, employeeAction } from '../../../actions/'
import { authSelector, divisionSelector, employeeSelector } from '../../../selectors'
import CustomTable from '../../../components/table'

const header = ['Start Date', 'Division ID', 'Division Name', 'Modified By']

class ListDivision extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      divisions: [],
    }
    this.handleClickEdit = this.handleClickEdit.bind(this)
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getEmployeeList(access_token)
    this.props.listDivision(access_token)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.listDivisionData) {
      this.setState({ divisions: nextProps.listDivisionData })
    }
  }
  handleClickEdit(id) {
    this.props.handleClickEdit(true, id)
    this.props.handleSpan(true)
  }
  render() {
    const IsAdminUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')

    if (IsHRConfidentialUser !== undefined &&
      IsSystemUser !== undefined &&
      IsAdminUser !== undefined &&
      IsManagementUser !== undefined &&
      !(IsHRConfidentialUser || IsSystemUser || IsAdminUser || IsManagementUser)) window.location = '/home'

    return (
    /* eslint no-underscore-dangle: 0 */
      <CustomTable
        header={ header }
        data={ this.props.divisions }
        handleClickEdit={ this.handleClickEdit }
        span={ get(this.props, 'span') }
        table={ this.props.table }
        employeeList={ this.props.employeeList }
      />
    )
  }
}

ListDivision.propTypes = {
  listDivision: PropTypes.func.isRequired,
  listDivisionData: PropTypes.object.isRequired,
  handleClickEdit: PropTypes.object.isRequired,
  handleSpan: PropTypes.object.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  listDivisionData: divisionSelector.getListDivision,
  divisionDeactivate: divisionSelector.getDeactivateDivisionData,
  redirectDivision: divisionSelector.redirectDivision,
  authData: authSelector.getAuth,
  employeeList: employeeSelector.getListUser,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  listDivision: divisionAction.getDivision,
  deactivateDivision: divisionAction.deactivateDivision,
  resetDeactivateDivision: divisionAction.resetDeactivateDivision,
  resetListDivision: divisionAction.resetListDivision,
  getEmployeeList: employeeAction.getUser,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ListDivision)



// WEBPACK FOOTER //
// ./src/pages/division/list/index.js